<template>
  <Modal :id="id" :modalTitle="modalTitle" :class="classes">
    <label class="generalLabel pt-1 pb-3">{{ confirmationMessage }}</label>

    <button class="btn btn-primary generalPrimaryButton float-right mt-4" aria-label="Close"
            @click="executeAction()" :disabled="loadingButton">
      <span v-if="loadingButton" class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
      <span v-if="loadingButton">Procesando...</span>
      <span v-else>Confirmar</span>
    </button>
    <button :id="id + 'CierreModal'" style="display: none;" data-dismiss="modal" />
  </Modal>
  <ModalError :id="id + 'Error'" :modalTitle="'SE HA PRODUCIDO UN ERROR'" :class="'modal'"
              :showFooter="false" :message="errorMessage" :code="errorCode" />
</template>

<script>
import Modal from '../../../Shared/Modal.vue';
import ModalError from '../../../Shared/ModalError.vue';
import { Modal as ModalBootstrap } from 'bootstrap';
import axios from 'axios';

export default {
  name: 'AlternativeBiometricsAction',
  props: ['id', 'modalTitle', 'class', 'contractId', 'actionType'],
  components: { Modal, ModalError },
  data() {
    return {
      classes: this.class,
      loadingButton: false,
      errorMessage: '',
      errorCode: ''
    };
  },
  computed: {
    confirmationMessage() {
      switch (this.actionType) {
        case 'ok':
          return 'Al pulsar el botón confirmar se aceptará la biometría alternativa. El contrato pasará a PTE FIRMA y el backend reenviará el correo del proceso al cliente.';
        case 'ko':
          return 'Al pulsar el botón confirmar se rechazará la biometría alternativa. El contrato quedará denegado/cancelado.';
        case 'tecalis':
          return 'Al pulsar el botón confirmar se cambiará el contrato a biometría estándar (Tecalis). El backend reenviará el correo al cliente con el nuevo enlace.';
        default:
          return '';
      }
    }
  },
  methods: {
    closeConfirmModal() {
      const closeBtn = document.getElementById(this.id + 'CierreModal');
      if (closeBtn) closeBtn.click();
    },
    showErrorModal() {
      const errorEl = document.getElementById(this.id + 'Error');
      if (errorEl) {
        new ModalBootstrap(errorEl).show();
      }
    },
    async executeAction() {
      if (this.loadingButton) return;
      if (!this.contractId) return;
      this.loadingButton = true;

      let request;
      if (this.actionType === 'ok') {
        request = axios.patch(`/contract/${this.contractId}/alternative-biometrics/confirm`, { accepted: true });
      } else if (this.actionType === 'ko') {
        request = axios.patch(`/contract/${this.contractId}/alternative-biometrics/confirm`, { accepted: false });
      } else if (this.actionType === 'tecalis') {
        request = axios.patch(`/contract/${this.contractId}/alternative-biometrics/switch-to-standard`);
      } else {
        this.loadingButton = false;
        return;
      }

      try {
        await request;
        this.closeConfirmModal();
        this.$emit('refrestContractList');
      } catch (error) {
        const status = error.response?.status;
        this.closeConfirmModal();
        if (status === 409) {
          this.errorMessage = 'El contrato ya no está pendiente de biometría alternativa. Se actualizará la lista para mostrar el estado real.';
          this.errorCode = '409';
          this.$emit('refrestContractList', { silent: true });
        } else {
          this.errorMessage = error.response?.data?.message || 'Ha ocurrido un error al procesar la biometría alternativa.';
          this.errorCode = String(error.response?.data?.code || status || '');
        }
        this.showErrorModal();
      } finally {
        this.loadingButton = false;
      }
    }
  }
};
</script>
